import { AbstractControl, ValidatorFn } from "@angular/forms";

export const futureDateValidator = ():ValidatorFn => {
    return (control:AbstractControl): { [key:string]:any } | null => {
        const currentDate = new Date();
        const inputDate = new Date(control.value);
    
        currentDate.setHours(0,0,0,0);
    
        return inputDate <= currentDate ? {'futureDate':true}:null;
    }
}




export const pastDateValidator = ():ValidatorFn => {
    return (control:AbstractControl): { [key:string]:any } | null => {
        const currentDate = new Date();
        const inputDate = new Date(control.value);


        currentDate.setHours(0,0,0,0);

        return inputDate > currentDate ? {'pastDate':true}:null;
    }
}


